import type { ReactNode, Ref } from "react";
import clsx from "clsx";

export function OverviewCard({
  title,
  children,
  className = "",
  fill = false,
  sectionRef,
}: {
  title: string;
  children: ReactNode;
  className?: string;
  /** Volle Höhe in der Notizen-Spalte (3-Spalten-Layout). */
  fill?: boolean;
  sectionRef?: Ref<HTMLElement>;
}) {
  return (
    <section
      ref={sectionRef}
      className={clsx("eh-po-card", fill && "eh-po-card--fill", className)}
    >
      <h3 className="eh-po-card-title">{title}</h3>
      {children}
    </section>
  );
}

export function MetaGrid({ children }: { children: ReactNode }) {
  return <dl className="eh-po-meta-grid">{children}</dl>;
}

export function MetaRow({ label, value }: { label: string; value: ReactNode }) {
  return (
    <>
      <dt>{label}</dt>
      <dd>{value ?? "—"}</dd>
    </>
  );
}
